import React from 'react';
import '../../css/components/QuestionContent/content_play.css';
import Solution from './Solution';
import Helpers from '../../utils/helpers';
// should implement some action here - now only used to preview
var MCQuestionContent = React.createClass({
  getInitialState: function() {
    return {
      kquestion: this.props.kquestion
    }
  },
  componentWillReceiveProps: function(nextProps) {
    var kquestion = this.state.kquestion;
    if (kquestion.concepts) {
      for (var i = 0; i < kquestion.concepts.length; i++) {
        if (this.props.conceptLeafMapping[kquestion.concepts[i]])
          kquestion.conceptLeafInfo = this.props.conceptLeafMapping[kquestion.concepts[i]];
      }
    }
    this.setState({
      kquestion: kquestion
    })
  },
  componentWillMount: function() {

  },
  render: function() {
    var _this = this,
        conceptMap = this.props.conceptLeafMapping;
    return (
      <div>
        <div className="text-desc">
          <span className="question-index">{_this.props.questionIndex+1}</span>
            {
              _this.state.kquestion.concepts && _this.state.kquestion.concepts[0] && conceptMap[_this.state.kquestion.concepts[0]] &&
              <span>
                {conceptMap[_this.state.kquestion.concepts[0]].title + " - "}
              </span>
            }
            <span>{_this.state.kquestion.score + (_this.state.kquestion.score > 1 ? " points" : " point")}</span>
        </div>
        <div className="content-title">
          <span dangerouslySetInnerHTML={{__html: Helpers.convertToHtml(_this.state.kquestion.description) || 'No title'}}></span>
          {
            _this.state.kquestion.image &&
            <img src={_this.state.kquestion.image}
              style={{"maxWidth": "500px", display: "block", margin: "10px auto"}}/>
          }
        </div>
        <div className="choice-wrapper">
          <ul className="choice-list">
            {
              _this.state.kquestion.selectionChoices.map(function(choice, index) {
                return (
                  <li className="choice" key={index}>
                    <input type="checkbox" id={"question-" + _this.props.questionIndex + "-choice-" + index}/>
                    <label className={choice.answerValue > 0 ? "is-right" : ""} htmlFor={"question-" + _this.props.questionIndex + "-choice-" + index}>
                      {
                        choice.image && <img alt="Choice" src={choice.image}/>
                      }
                      {
                        choice.text ? (<p dangerouslySetInnerHTML={{__html: choice.text}}></p>) : (<p>No text</p>)
                      }
                    </label>
                  </li>
                )
              })
            }
          </ul>
        </div>
        {
          _this.state.kquestion.solution.length > 0 &&
          <Solution solution={_this.state.kquestion.solution} />
        }
        <hr />
      </div>
    )
  },
  componentDidMount: function() {

  },
  componentDidUpdate: function() {

  }
})

export default MCQuestionContent;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/MCQuestion.js
 **/